import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
const autoSuggestionFilledEvent = {
    event: 'auto suggestion filled',
    data: {},
};
/** Shares fill-arrow behavior and its existing event without dispatching a row submission. */
export function useFillSuggestion(fillInput) {
    const { track } = useInstrumentation();
    return useCallback((fillText, url) => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
            return;
        }
        track(autoSuggestionFilledEvent);
        fillInput(fillText);
    }, [fillInput, track]);
}
//# sourceMappingURL=useFillSuggestion.js.map